import React from 'react';
import './LogoHeader.component.css';

export default class LogoHeader extends React.Component {

    render() {
        return (
            <div className="logo-header-container">
                <img src="https://schneider.com/resources/sdc/images/img-sni-logo.png" alt="www.schneider.com" className="logo-header" />
            </div>
        );
    }
}